// extracted by mini-css-extract-plugin
export default {"icon":"Warning_icon__RlITl","textContainer":"Warning_textContainer__ZtBPd","actionContainer":"Warning_actionContainer__bcusR"};